import React, {useEffect, useState} from 'react';
import {themeOptions} from '../../utils/utils';
import {ThemeContext} from './themeContext';

const ThemeService = (props: any) => {
    const [theme, setThemeCtx] = useState(localStorage.getItem('theme') || themeOptions[0]);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

        const handleSystemThemeChange = (e: MediaQueryListEvent) => {
            const newTheme = e.matches ? 'theme-dark' : 'theme-light';
            setThemeCtx(newTheme);
            localStorage.setItem('theme', newTheme);
            document.documentElement.className = newTheme;
            document.location.reload();
        };

        mediaQuery.addEventListener('change', handleSystemThemeChange);
        return () => {
            mediaQuery.removeEventListener('change', handleSystemThemeChange);
        };
    }, []);

    useEffect(() => {
        localStorage.setItem('theme', theme);
        document.documentElement.className = theme;
    }, [theme]);

    const setTheme = (newTheme: string) => {
        setThemeCtx(newTheme);
    };

    const getTheme = () => theme;

    return (
        <ThemeContext.Provider value={{setTheme, getTheme}}>
            {props.children}
        </ThemeContext.Provider>
    );
};

export {ThemeService};
